import React from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from '../../hooks/i18n';
import * as S from './styles/ItineraryComparison.style';
import { WarningFilled } from '@hangar/react-icons/core/interaction/WarningFilled';

export const CompleteLoadMessage: React.FC = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const iconColor = theme?.tokens?.color?.icon?.info ?? '#0d12ab';
    
    return (
        <S.PartializedLoadBadge role="status" aria-label={t('itinerary.completeLoad')}>
            <S.PartializedLoadIcon aria-hidden="true">
                <WarningFilled size={16} color={iconColor} />
            </S.PartializedLoadIcon>
            <S.PartializedLoadText>
                {t('itinerary.completeLoad')}
            </S.PartializedLoadText>
        </S.PartializedLoadBadge>
    );
};

